import React from "react";
import Icon from "@ant-design/icons";

const METABASE_BLUE = "#509EE2";
const METABASE_LIGHT_BLUE = "#DDEBF9";

// Metabase logosu: 5x6'lık nokta ızgarası, yarıçap 15.5514 (orijinal 212x256 viewBox)
const SOLID_DOTS = [
    [15.5514, 60.5308],
    [15.5514, 105.51],
    [15.5514, 150.49],
    [15.5514, 195.469],
    [60.5309, 105.51],
    [105.51, 150.49],
    [150.49, 105.51],
    [195.469, 60.5308],
    [195.469, 105.51],
    [195.469, 150.49],
    [195.469, 195.469]
];

const LIGHT_DOTS = [
    [60.5309, 60.5308],
    [60.5309, 150.49],
    [60.5309, 195.469],
    [105.51, 15.5514],
    [105.51, 60.5308],
    [105.51, 105.51],
    [105.51, 195.469],
    [105.51, 240.449],
    [150.49, 60.5308],
    [150.49, 150.49],
    [150.49, 195.469]
];

const MetabaseLogoSvg = () => (
    <svg viewBox="0 0 212 256" focusable="false" width="1em" height="1em">
        {SOLID_DOTS.map(([cx, cy]) => (
            <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="15.5514" fill={METABASE_BLUE} />
        ))}
        {LIGHT_DOTS.map(([cx, cy]) => (
            <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="15.5514" fill={METABASE_LIGHT_BLUE} />
        ))}
    </svg>
);

export const MetabaseLogoIcon = ({size = 18, style, ...props}) => (
    <Icon component={MetabaseLogoSvg} style={{fontSize: size, ...style}} {...props} />
);
